<template>
  <transition name="slide-up">
  <section @scroll="checkIfOnBottom" ref="mainContainer" @click.self="$emit('toggleTab',false)" v-if="isTabOpened" class="w-full h-full fixed top-0 left-0 overflow-x-hidden z-40 flex md:block pb-5" style="padding-top: 10vh">
    <main ref="tabContainer" class=" z-30 bg-white rounded-t-2xl md:rounded-2xl shadow-xl w-full max-w-full md:max-w-screen-md p-10 border-t-2 border-gray-200 mx-auto h-max mt-auto md:mt-0 relative">
      <div>
        <div>
          <h4 class="text-purple-400 text-md tracking-wide font-bold uppercase w-full text-center my-4">
          {{tabName}}
          </h4>
        </div>
        <div @click="$emit('toggleTab',false)" class="w-max px-3 py-1 absolute top-2 right-5 text-gray-500 font-bold pop-click transition-all">
          <h6>x</h6>
        </div>
      </div>
      <slot></slot>
    </main>
  </section>
  </transition>
</template>

<script>
export default {
  emits : ['toggleTab','bottomScrolled','opened'],
  props : {
    tabName : String,
    isTabOpened : Boolean,
    willCheckScroll : Boolean
  },
  methods : {
    checkIfOnBottom() {
      if(!this.willCheckScroll)return;
      const mainContainer = this.$refs.mainContainer;
      const tabContainer = this.$refs.tabContainer;
      if ((mainContainer.offsetHeight + mainContainer.scrollTop) >= (tabContainer.offsetHeight) ) {
        this.$emit('bottomScrolled');
      }
      // console.log(mainContainer.scrollTop,tabContainer.offsetHeight)
    }
  },
  watch : {
    isTabOpened(isOpened){
      if(isOpened)this.$emit('opened');
    }
  }
}
</script>

<style>

</style>